import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from 'axios';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import {
    LIST_ENTITY_ASSESSMENTS,
} from '@/utils/constants/constants';

export default ({
    name: "EntityRiskAssessment",
    mixins: [alert_mixin],
    components: {
        GlobalTable,
        AICampusFooter,
        NavigationBackButton
    },
    data: () => ({
        headers: '',
        form_list: [],
        form_table_headers: [],
        table_safe_form_list: [],
        total_assessment_count: 0,
        total_pre_assessment_count: 0,
        total_post_assessment_count: 0,
    }),
    mounted() {
        this.fetch_assessments();
    },
    methods: {
        prep_tables() {
            if (!this.form_list.length) {
                this.table_safe_form_list = [];
                return;
            }

            const table_data = this.form_list.map(a => ({
                'Assessment ID': a.id,
                'Name' : a.name,
                'Phase' : a.phase,
                'Questions' : a.questions.length,
                'Date Created' : a.date_created
            }));

            this.form_table_headers = Object.keys(table_data[0]);
            this.table_safe_form_list = table_data;

        },

        async fetch_assessments() {
            const entity_type_id = sessionStorage.getItem('entity_type_id');
            if (!entity_type_id) return;
            await this.fetch_entity_assessments(entity_type_id);
        },
        /* eslint-disable no-useless-catch */
        fetch_entity_assessments(entity_type_id) {
            return axios
            .get(LIST_ENTITY_ASSESSMENTS, {
                params: { entity_type_id },
                headers: this.headers || {}
            })
            .then(({ data: body }) => {
                if (body.status === 'success') {
                this.total_assessment_count = body.total_assessments;
                this.total_pre_assessment_count  = body.total_pre_assessments;
                this.total_post_assessment_count = body.total_post_assessments;
                this.form_list = [
                    ...body.pre_assessments,
                    ...body.post_assessments
                ];
                } else {
                this.form_list = [];
                }
                this.prep_tables();
            })
            .catch(err => {
                if (err.response?.status === 404) {
                // no data → show empty table
                this.form_list = [];
                return this.prep_tables();
                }
                const msg =
                err.response?.data?.message ||
                (typeof err.response?.data === 'string' ? err.response.data : null) ||
                err.message;
                this.show_error('Error fetching assessments', msg);
            });
        },

        redirect_to_answer_assessments() {
            this.$router.push({
                path: '/answer_risk_assessment',
            });
        },
    },
})